import React from "react";

import ThemeContext from "./ThemeContext";

const useMyDpdTheme = () => React.useContext(ThemeContext);

export default useMyDpdTheme;
